import React, { useContext } from 'react';
import './ContentLocked.scss';
import Button, { BUTTON_VARIANTS } from '../UI/Button/Button';
import { ModalContext } from '../ModalManager';
import classNames from 'classnames';
import CONTENT_RESTRICTION_RULE from '../../../const/contentRestrictionRule';

export const CONTENT_LOCKED_TYPES = {
    [CONTENT_RESTRICTION_RULE.PROFILE_COLLECTIONS_LOCKED] : {
        title : "Accédez aux collections photos et vidéos de milliers de membres !",
        btnVariant : BUTTON_VARIANTS.REVERSE
    },
    [CONTENT_RESTRICTION_RULE.VIDEO_DURATION_LIMIT] : {
        title : "Inscrivez-vous pour accéder à la vidéo complète",
        btnVariant : BUTTON_VARIANTS.DARKEN,
        styleVariant : 'amv'
    },
    [CONTENT_RESTRICTION_RULE.PROFILE_PUBLICATION_LIMIT] : {
        title : "Envie de voir plus de 10 publications ? Créez votre compte !",
        btnVariant : BUTTON_VARIANTS.REVERSE
    },
}

const ContentLocked = ({testVariant, restrictionRule, ...props}) => {
    const { openModal } = useContext(ModalContext);
    const selectedType = CONTENT_LOCKED_TYPES[restrictionRule];
    if(!selectedType){
        return null;
    }
    const context = {
        testVariant,
        restrictionRule
    }

    const handleSignuo = () => {
        openModal('Signup', { context });
    }
    return (
        <div className={classNames('content-locked', selectedType.styleVariant)} {...props}>
            <div className="content-locked-wrapper">
                <div className="content-locked-title">{selectedType.title}</div>
                <Button variant={selectedType.btnVariant} big onClick={handleSignuo}>Créer mon compte</Button>
            </div>
        </div>
    );
}

export default ContentLocked;